var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !this.siteName &&
    !_vm.forDenomination &&
    !_vm.forFinder &&
    !_vm.websiteFocus
      ? _c("h1", [_vm._v(_vm._s(_vm.$t("register.header")))])
      : _vm._e(),
    _vm._v(" "),
    !this.siteName && !_vm.forDenomination && !_vm.forFinder && _vm.websiteFocus
      ? _c("h1", [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("register.headerWebsite")) + "\n    "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !this.siteName && !_vm.forDenomination && _vm.forFinder
      ? _c("h1", [_vm._v(_vm._s(_vm.$t("register.headerFinder")))])
      : _vm._e(),
    _vm._v(" "),
    !this.siteName && _vm.forDenomination && !_vm.websiteFocus
      ? _c("h1", [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.updateAdminOnly
                  ? _vm.$t("register.headerDenominationUpdateAdmin")
                  : _vm.$t("register.headerDenomination")
              ) +
              "\n        " +
              _vm._s(_vm.denominationName) +
              "\n    "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !this.siteName && _vm.forDenomination && _vm.websiteFocus
      ? _c("h1", [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("register.headerDenominationWebsite")) +
              "\n        " +
              _vm._s(_vm.denominationName) +
              "\n    "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    this.siteName
      ? _c("h1", [_vm._v(_vm._s(_vm.$t("register.headerinstanceavailable")))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "ct-register-form ct-card form-horizontal",
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.sendRegistration()
          }
        }
      },
      [
        _c("Language"),
        _vm._v(" "),
        _vm.useStandardPortal && _vm.websiteFocus
          ? _c("section", [
              _c(
                "div",
                {
                  staticClass: "ct-input-element",
                  staticStyle: { "margin-top": "8rem" }
                },
                [
                  _c("h4", { staticStyle: { "text-align": "center" } }, [
                    _vm._v(_vm._s(_vm.$t("label.alreadyCustomer")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "ct-input-element" }, [
                _c("div", {
                  staticClass: "ct-hint",
                  staticStyle: { "white-space": "unset", color: "#333" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("hint.startTestphaseFromChurchTools")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _vm.cwbKircheHamburg
                ? _c("div", { staticClass: "ct-input-element" }, [
                    _c("div", {
                      staticClass: "ct-hint",
                      staticStyle: { "white-space": "unset", color: "#333" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("hint.contactSupportForCWBKircheHamburg")
                        )
                      }
                    })
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.useStandardPortal && !_vm.websiteFocus
          ? _c(
              "section",
              [
                _c("h3", [_vm._v(_vm._s(_vm.$t("label.niceHeader")))]),
                _vm._v(" "),
                _c("text-area", {
                  attrs: {
                    config: {
                      translationKey: "label.problemHeader",
                      required: true,
                      id: "problem",
                      type: "text",
                      maxlength: 255,
                      rows: 3
                    },
                    "input-model": _vm.register.problem,
                    error: _vm.getError("problem")
                  },
                  on: {
                    "update:inputModel": function($event) {
                      return _vm.$set(_vm.register, "problem", $event)
                    },
                    "update:input-model": function($event) {
                      return _vm.$set(_vm.register, "problem", $event)
                    },
                    resetValidation: function($event) {
                      return _vm.resetValidation("problem")
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "ct-input-element" }, [
                  _c("div", {
                    staticClass: "ct-hint",
                    staticStyle: { "white-space": "unset" },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("label.problemDescription"))
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.register.registrationLanguage === "de" ||
                _vm.register.registrationLanguage === "de-kr"
                  ? _c("div", [
                      _c("div", { staticClass: "ct-input-element" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("label", { attrs: { for: "just-looking" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.justLooking,
                                  expression: "justLooking"
                                }
                              ],
                              attrs: {
                                name: "checkjustlooking",
                                type: "checkbox",
                                id: "just-looking"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.justLooking)
                                  ? _vm._i(_vm.justLooking, null) > -1
                                  : _vm.justLooking
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.justLooking,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.justLooking = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.justLooking = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.justLooking = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("label.justLooking"))
                              }
                            })
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.justLooking
                        ? _c("div", { staticClass: "ct-input-element" }, [
                            _c("div", {
                              staticClass: "ct-hint",
                              staticStyle: { "white-space": "unset" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("label.justLookingDescription")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.justLooking
                        ? _c("div", { staticClass: "ct-input-element" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.jumpToDemo(_vm.$t("link.demo"))
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("button.demo")) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.useStandardPortal && !_vm.websiteFocus
          ? _c("section", { staticClass: "ct-border" })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "section",
          { style: _vm.mainSectionStyle },
          [
            _vm.useStandardPortal && !_vm.websiteFocus
              ? _c("h3", [_vm._v(_vm._s(_vm.$t("label.andNowAFewDetails")))])
              : _vm._e(),
            _vm._v(" "),
            _vm.useStandardPortal && !_vm.websiteFocus
              ? _c("h3", { staticStyle: { "text-align": "right" } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("label.detailsAboutYourChurch")) +
                      "\n            "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.useStandardPortal && _vm.websiteFocus
              ? _c("h3", [_vm._v(_vm._s(_vm.$t("label.notYetCustomer")))])
              : _vm._e(),
            _vm._v(" "),
            !_vm.useStandardPortal
              ? _c("h3", [
                  _vm._v(_vm._s(_vm.$t("label.churchinformationDenomination")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.useStandardPortal && _vm.websiteFocus
              ? _c("div", { staticClass: "ct-input-element" }, [
                  _c("div", {
                    staticClass: "ct-hint",
                    staticStyle: { "white-space": "unset" },
                    domProps: { innerHTML: _vm._s(_vm.$t("hint.freeCombo")) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.updateAdminOnly
              ? _c(
                  "div",
                  [
                    !_vm.cwbKircheHamburg
                      ? _c("text-input", {
                          attrs: {
                            config: {
                              translationKey: "label.churchname",
                              required: true,
                              id: "church-name"
                            },
                            "input-model": _vm.register.churchName,
                            error: _vm.getError("churchName")
                          },
                          on: {
                            "update:inputModel": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "churchName",
                                $event
                              )
                            },
                            "update:input-model": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "churchName",
                                $event
                              )
                            },
                            resetValidation: function($event) {
                              return _vm.resetValidation("churchName")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cwbKircheHamburg
                      ? _c("select-input", {
                          attrs: {
                            config: {
                              translationKey: "label.churchname",
                              required: true,
                              id: "church-name"
                            },
                            options: _vm.kircheHamburgChurchesOptions,
                            "input-model": _vm.register.churchName,
                            error: _vm.getError("churchName")
                          },
                          on: {
                            "update:inputModel": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "churchName",
                                $event
                              )
                            },
                            "update:input-model": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "churchName",
                                $event
                              )
                            },
                            resetValidation: function($event) {
                              return _vm.resetValidation("churchName")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cwbNordkirche && !_vm.cwbKircheHamburg
                      ? _c("text-input", {
                          attrs: {
                            config: {
                              translationKey: "label.institutionId",
                              required: false,
                              id: "institutionId",
                              hint: "hint.institutionId"
                            },
                            "input-model": _vm.register.institutionId,
                            error: _vm.getError("institutionId")
                          },
                          on: {
                            "update:inputModel": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "institutionId",
                                $event
                              )
                            },
                            "update:input-model": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "institutionId",
                                $event
                              )
                            },
                            resetValidation: function($event) {
                              return _vm.resetValidation("institutionId")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("text-input", {
                      attrs: {
                        config: {
                          translationKey: "label.city",
                          required: true,
                          id: "city"
                        },
                        "input-model": _vm.register.city,
                        error: _vm.getError("city")
                      },
                      on: {
                        "update:inputModel": function($event) {
                          return _vm.$set(_vm.register, "city", $event)
                        },
                        "update:input-model": function($event) {
                          return _vm.$set(_vm.register, "city", $event)
                        },
                        resetValidation: function($event) {
                          return _vm.resetValidation("city")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ct-row two-elements" },
                      [
                        _c("select-input", {
                          attrs: {
                            config: {
                              translationKey: "label.countrycode",
                              required: true,
                              id: "country-code",
                              prefix: "countries",
                              preferredOptions: _vm.preferredCountries
                            },
                            options: _vm.countries,
                            "input-model": _vm.register.countryCode,
                            error: _vm.getError("countryCode")
                          },
                          on: {
                            "update:inputModel": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "countryCode",
                                $event
                              )
                            },
                            "update:input-model": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "countryCode",
                                $event
                              )
                            },
                            resetValidation: function($event) {
                              return _vm.resetValidation("countryCode")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("select-input", {
                          attrs: {
                            config: {
                              translationKey: "label.baselanguage.short",
                              required: true,
                              id: "base-language",
                              prefix: "languages",
                              hint: "label.baselanguage.long"
                            },
                            options: _vm.dropdownLanguages,
                            "input-model": _vm.register.baseLanguage,
                            error: _vm.getError("baseLanguage"),
                            "pre-select": _vm.register.registrationLanguage
                          },
                          on: {
                            "update:inputModel": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "baseLanguage",
                                $event
                              )
                            },
                            "update:input-model": function($event) {
                              return _vm.$set(
                                _vm.register,
                                "baseLanguage",
                                $event
                              )
                            },
                            resetValidation: function($event) {
                              return _vm.resetValidation("baseLanguage")
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("text-input", {
                      attrs: {
                        config: {
                          translationKey: _vm.websiteFocus
                            ? "label.currentWebsite"
                            : "label.website",
                          id: "website"
                        },
                        "input-model": _vm.register.website,
                        error: _vm.getError("website")
                      },
                      on: {
                        "update:inputModel": function($event) {
                          return _vm.$set(_vm.register, "website", $event)
                        },
                        "update:input-model": function($event) {
                          return _vm.$set(_vm.register, "website", $event)
                        },
                        resetValidation: function($event) {
                          return _vm.resetValidation("website")
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("check-input", {
              attrs: {
                config: _vm.getDomainConfig(),
                "input-model": _vm.register.siteName,
                error: _vm.getError("siteName"),
                icon: _vm.checkIcon,
                iconClass: _vm.checkIconClass
              },
              on: {
                "update:inputModel": function($event) {
                  return _vm.$set(_vm.register, "siteName", $event)
                },
                "update:input-model": function($event) {
                  return _vm.$set(_vm.register, "siteName", $event)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        !_vm.createSiteOnly
          ? _c(
              "section",
              { staticClass: "ct-border" },
              [
                _vm.useStandardPortal && _vm.websiteFocus
                  ? _c("h3", [_vm._v(_vm._s(_vm.$t("label.contactperson")))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.useStandardPortal && !_vm.websiteFocus
                  ? _c("h3", { staticStyle: { "text-align": "right" } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("label.detailsAboutYou")) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.useStandardPortal
                  ? _c("h3", [
                      _vm._v(_vm._s(_vm.$t("label.contactpersonDenomination")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("select-input", {
                  attrs: {
                    config: {
                      translationKey: "hint.appellation",
                      required: true,
                      id: "appellation",
                      prefix: "appellation"
                    },
                    options: _vm.appellationOptions,
                    "input-model": _vm.register.appellation,
                    error: _vm.getError("appellation")
                  },
                  on: {
                    "update:inputModel": function($event) {
                      return _vm.$set(_vm.register, "appellation", $event)
                    },
                    "update:input-model": function($event) {
                      return _vm.$set(_vm.register, "appellation", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ct-row two-elements" },
                  [
                    _c("text-input", {
                      attrs: {
                        config: {
                          translationKey: "label.firstname",
                          required: true,
                          id: "firstname"
                        },
                        "input-model": _vm.register.firstName,
                        error: _vm.getError("firstName")
                      },
                      on: {
                        "update:inputModel": function($event) {
                          return _vm.$set(_vm.register, "firstName", $event)
                        },
                        "update:input-model": function($event) {
                          return _vm.$set(_vm.register, "firstName", $event)
                        },
                        resetValidation: function($event) {
                          return _vm.resetValidation("firstName")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("text-input", {
                      attrs: {
                        config: {
                          translationKey: "label.lastname",
                          required: true,
                          id: "lastname"
                        },
                        "input-model": _vm.register.lastName,
                        error: _vm.getError("lastName")
                      },
                      on: {
                        "update:inputModel": function($event) {
                          return _vm.$set(_vm.register, "lastName", $event)
                        },
                        "update:input-model": function($event) {
                          return _vm.$set(_vm.register, "lastName", $event)
                        },
                        resetValidation: function($event) {
                          return _vm.resetValidation("lastName")
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("text-input", {
                  attrs: {
                    config: {
                      translationKey: "label.email",
                      required: true,
                      id: "email"
                    },
                    "input-model": _vm.register.email,
                    error: _vm.getError("email")
                  },
                  on: {
                    "update:inputModel": function($event) {
                      return _vm.$set(_vm.register, "email", $event)
                    },
                    "update:input-model": function($event) {
                      return _vm.$set(_vm.register, "email", $event)
                    },
                    resetValidation: function($event) {
                      return _vm.resetValidation("email")
                    }
                  }
                }),
                _vm._v(" "),
                _vm.useStandardPortal
                  ? _c("phone-input", {
                      attrs: {
                        config: {
                          translationKey: "label.phone",
                          required: true,
                          id: "phone"
                        },
                        "input-model": _vm.register.phone,
                        error: _vm.getError("phone"),
                        country: _vm.register.countryCode
                      },
                      on: {
                        "update:inputModel": function($event) {
                          return _vm.$set(_vm.register, "phone", $event)
                        },
                        "update:input-model": function($event) {
                          return _vm.$set(_vm.register, "phone", $event)
                        },
                        resetValidation: function($event) {
                          return _vm.resetValidation("phone")
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.createSiteOnly
          ? _c(
              "section",
              { staticClass: "ct-border ct-small-text" },
              [
                !_vm.forDenomination
                  ? _c("select-input", {
                      attrs: {
                        config: {
                          translationKey: "hint.heardfrom",
                          required: true,
                          id: "heard-from",
                          prefix: "heardfrom"
                        },
                        options: _vm.heardFromOptions,
                        "input-model": _vm.register.heardFrom,
                        error: _vm.getError("heardFrom"),
                        preSelect: _vm.heardFromPreselect
                      },
                      on: {
                        "update:inputModel": function($event) {
                          return _vm.$set(_vm.register, "heardFrom", $event)
                        },
                        "update:input-model": function($event) {
                          return _vm.$set(_vm.register, "heardFrom", $event)
                        },
                        resetValidation: function($event) {
                          return _vm.resetValidation("heardFrom")
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.forDenomination
                  ? _c("text-input", {
                      attrs: {
                        config: {
                          translationKey: "label.discountcode",
                          id: "discountcode",
                          hint: "hint.discountcode"
                        },
                        "input-model": _vm.register.discountCode,
                        hide: !_vm.showDiscountCode
                      },
                      on: {
                        "update:inputModel": function($event) {
                          return _vm.$set(_vm.register, "discountCode", $event)
                        },
                        "update:input-model": function($event) {
                          return _vm.$set(_vm.register, "discountCode", $event)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "ct-input-element" }, [
                  _c("div", { staticClass: "checkbox" }, [
                    _c("label", { attrs: { for: "newsletter-check" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.register.checknewsletter,
                            expression: "register.checknewsletter"
                          }
                        ],
                        attrs: {
                          name: "checknewsletter",
                          type: "checkbox",
                          id: "newsletter-check"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.register.checknewsletter)
                            ? _vm._i(_vm.register.checknewsletter, null) > -1
                            : _vm.register.checknewsletter
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.register.checknewsletter,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.register,
                                    "checknewsletter",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.register,
                                    "checknewsletter",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.register, "checknewsletter", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.useStandardPortal
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("label.checknewsletter"))
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.useStandardPortal
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("label.checknewsletterDenomination")
                              )
                            }
                          })
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.useStandardPortal
                  ? _c("div", { staticClass: "ct-input-element" }, [
                      _c(
                        "div",
                        {
                          staticClass: "checkbox",
                          class: {
                            "has-error":
                              _vm.showValidationsErrors["checkagbs"] &&
                              !_vm.register.checkagbs
                          }
                        },
                        [
                          _c("label", { attrs: { for: "agb-check" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.register.checkagbs,
                                  expression: "register.checkagbs"
                                }
                              ],
                              attrs: {
                                name: "checkagbs",
                                type: "checkbox",
                                id: "agb-check"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.register.checkagbs)
                                  ? _vm._i(_vm.register.checkagbs, null) > -1
                                  : _vm.register.checkagbs
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.register.checkagbs,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.register,
                                          "checkagbs",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.register,
                                          "checkagbs",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.register, "checkagbs", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("label.checkagbs", {
                                    link: _vm.agb_link
                                  })
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.showValidationsErrors["checkagbs"] &&
                                    !_vm.register.checkagbs,
                                  expression:
                                    "showValidationsErrors['checkagbs'] && !register.checkagbs"
                                }
                              ],
                              staticClass: "help-block has-error"
                            },
                            [_vm._v(_vm._s(_vm.getError("checkagbs")))]
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.useStandardPortal
                  ? _c("div", { staticClass: "ct-input-element" }, [
                      _c(
                        "div",
                        {
                          staticClass: "checkbox",
                          class: {
                            "has-error":
                              _vm.showValidationsErrors["checkgdpr"] &&
                              !_vm.register.checkgdpr
                          }
                        },
                        [
                          _c("label", { attrs: { for: "gdpr-check" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.register.checkgdpr,
                                  expression: "register.checkgdpr"
                                }
                              ],
                              attrs: {
                                name: "checkgdpr",
                                type: "checkbox",
                                id: "gdpr-check"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.register.checkgdpr)
                                  ? _vm._i(_vm.register.checkgdpr, null) > -1
                                  : _vm.register.checkgdpr
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.register.checkgdpr,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.register,
                                          "checkgdpr",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.register,
                                          "checkgdpr",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.register, "checkgdpr", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("label.checkgdpr", {
                                    link: _vm.gdpr_link
                                  })
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.showValidationsErrors["checkgdpr"] &&
                                    !_vm.register.checkgdpr,
                                  expression:
                                    "showValidationsErrors['checkgdpr'] && !register.checkgdpr"
                                }
                              ],
                              staticClass: "help-block has-error"
                            },
                            [_vm._v(_vm._s(_vm.getError("checkgdpr")))]
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.allowSetupService
          ? _c(
              "section",
              { staticClass: "ct-border" },
              [
                _c("h3", [_vm._v(_vm._s(_vm.$t("label.setupService")))]),
                _vm._v(" "),
                _c("div", { staticClass: "ct-input-element" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ct-hint",
                      staticStyle: { "white-space": "unset" }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.setupServiceMandatory &&
                              _vm.hasSetupMeetingOptions
                              ? _vm.$t("hint.setupServiceMandatory")
                              : _vm.$t("hint.setupServiceOptional")
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                !_vm.setupServiceMandatory
                  ? _c("div", { staticClass: "ct-input-element" }, [
                      _c("div", { staticClass: "checkbox" }, [
                        _c("label", { attrs: { for: "setup-service-check" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.register.withSetupService,
                                expression: "register.withSetupService"
                              }
                            ],
                            attrs: {
                              name: "checksetupservice",
                              type: "checkbox",
                              id: "setup-service-check"
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.register.withSetupService
                              )
                                ? _vm._i(_vm.register.withSetupService, null) >
                                  -1
                                : _vm.register.withSetupService
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.register.withSetupService,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.register,
                                        "withSetupService",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.register,
                                        "withSetupService",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.register,
                                    "withSetupService",
                                    $$c
                                  )
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("label.useSetupService"))
                            }
                          })
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.register.withSetupService
                  ? _c("select-input", {
                      attrs: {
                        config: {
                          translationKey: "label.setupMeeting",
                          required: true,
                          id: "setupMeetingDate",
                          noSort: true
                        },
                        options: _vm.setupMeetingOptions,
                        "input-model": _vm.register.setupMeetingDate,
                        error: _vm.getError("setupMeetingDate")
                      },
                      on: {
                        "update:inputModel": function($event) {
                          return _vm.$set(
                            _vm.register,
                            "setupMeetingDate",
                            $event
                          )
                        },
                        "update:input-model": function($event) {
                          return _vm.$set(
                            _vm.register,
                            "setupMeetingDate",
                            $event
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showWebsiteCheckbox
          ? _c("section", { staticClass: "ct-border" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("label.churchtoolsWebsite")))]),
              _vm._v(" "),
              _c("div", { staticClass: "ct-input-element" }, [
                _c("div", {
                  staticClass: "ct-hint",
                  staticStyle: { "white-space": "unset" },
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("hint.churchtoolsWebsite"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ct-input-element" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("label", { attrs: { for: "website-check" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.register.withWebsite,
                          expression: "register.withWebsite"
                        }
                      ],
                      attrs: {
                        name: "checkwithwebsite",
                        type: "checkbox",
                        id: "website-check"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.register.withWebsite)
                          ? _vm._i(_vm.register.withWebsite, null) > -1
                          : _vm.register.withWebsite
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.register.withWebsite,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.register,
                                  "withWebsite",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.register,
                                  "withWebsite",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.register, "withWebsite", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("label.registerWebsite"))
                      }
                    })
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("section", { staticClass: "ct-action" }, [
          _c("div", { staticClass: "ct-input-element" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-lg btn-block",
                attrs: { type: "button", disabled: _vm.registering },
                on: {
                  click: function($event) {
                    return _vm.sendRegistration()
                  }
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.registering
                        ? _vm.$t("button.registering")
                        : _vm.$t("button.register")
                    ) +
                    "\n                "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm.useStandardPortal && !_vm.forFinder
            ? _c("div", { staticClass: "ct-input-element" }, [
                _c("div", { staticClass: "ct-hint" }, [
                  _vm._v(_vm._s(_vm.registrationHint))
                ])
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1332f30", { render: render, staticRenderFns: staticRenderFns })
  }
}